"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = require("lodash");
const NotificationUsersOptions_1 = __importDefault(require("./NotificationUsersOptions"));
const FooterComponent_1 = __importDefault(require("./FooterComponent"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const utils_1 = require("../../../reviews-modal/utils");
const helper_1 = require("../../helper");
const ManageNotificationsModal = (props) => {
    const { open, onModalClose, onCallback, roundId, reviewers, jobId } = props;
    const [subject, setSubject] = (0, react_1.useState)('');
    const [message, setMessage] = (0, react_1.useState)('');
    const [users, setUsers] = (0, react_1.useState)([]);
    const [errorSubject, setErrorSubject] = (0, react_1.useState)(false);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!reviewers) {
            const action = 'job-team';
            utils_1.v2EndpointCustom
                .get(`/api.v2.php?action=${action}&jobId=${jobId}&review_round_id=${roundId}`)
                .then(({ data }) => {
                var _a, _b, _c;
                if ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.users) {
                    setUsers((_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.users) === null || _c === void 0 ? void 0 : _c.map((user) => {
                        return {
                            ...user,
                            avatar_url: `${helper_1.URLS.pulse}/getUserProfileImage.php?id=${user === null || user === void 0 ? void 0 : user.avatarUrl}`,
                            selected: false,
                        };
                    }));
                }
            });
        }
    }, [jobId]);
    (0, react_1.useEffect)(() => {
        if (reviewers) {
            const listReviewer = reviewers === null || reviewers === void 0 ? void 0 : reviewers.map((reviewer) => {
                return {
                    ...reviewer,
                    selected: false,
                };
            });
            setUsers([...listReviewer]);
        }
    }, [reviewers]);
    const onChangeSubject = (0, lodash_1.debounce)((e) => {
        setErrorSubject(!e.target.value);
        setSubject(e.target.value);
    }, 500);
    const onChangeMessage = (0, lodash_1.debounce)((e) => {
        setErrorMessage(!e.target.value);
        setMessage(e.target.value);
    }, 500);
    const onChangeSelectedOption = (user) => {
        const index = users.indexOf(user);
        user.selected = !user.selected;
        const newUsers = [...users];
        newUsers[index] = user;
        setUsers(newUsers);
    };
    const onSelectAllOption = () => {
        const selectedOptions = users.filter((option) => {
            return !!option.selected;
        });
        const updateOptions = users.map((user) => {
            return { ...user, selected: selectedOptions.length !== users.length };
        });
        setUsers(updateOptions);
    };
    const onSearchOption = (filterText) => {
        const filtersName = users.filter((user) => {
            return user.name
                ? user.name.toLocaleLowerCase().includes(filterText.toLocaleLowerCase())
                : false;
        });
        const filtersRole = users.filter((user) => {
            var _a;
            return (_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().includes(filterText.toLocaleLowerCase());
        });
        const filters = [...filtersName, ...filtersRole];
        const res = filters.filter((item, index) => {
            return filters.indexOf(item) === index;
        });
        return res;
    };
    const onValidateInputFields = (subjectText, messageText) => {
        setErrorSubject(!subjectText);
        setErrorMessage(!messageText);
    };
    const onAddSelectedUser = (user) => {
        if (users.indexOf(user) < 0) {
            const updateUsers = [user, ...users];
            updateUsers[0].selected = true;
            setUsers([...updateUsers]);
        }
    };
    return (react_1.default.createElement(pulse_components_1.PulseModalBase, { classes: {
            root: [styles_modules_less_1.default['notifications-modal__root']],
            dialog: {
                paper: (0, clsx_1.default)(styles_modules_less_1.default['notification-modal__container']),
            },
        }, PulseModalHeaderProps: {
            classes: {
                root: styles_modules_less_1.default['notifications-modal__header--root'],
                titlePrimary: styles_modules_less_1.default['notifications-modal__header--title'],
            },
            headerIconClasses: (0, clsx_1.default)(styles_modules_less_1.default['notifications-modal__header--icon'], 'fal fa-users'),
            primaryText: 'notify reviewers',
        }, open: open, onModalClose: onModalClose, footerComponent: react_1.default.createElement(FooterComponent_1.default, { subject: subject, message: message, users: users, validate: onValidateInputFields, onCallback: onCallback, roundId: roundId, onModalClose: onModalClose }) },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_modules_less_1.default['notifications-modal__input-ctn'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['notifications-modal__title'] },
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['notifications-modal__title--ctn'] },
                        react_1.default.createElement("label", { className: styles_modules_less_1.default['title--label'] }, "Email subject"),
                        react_1.default.createElement(pulse_components_1.PulseTooltip, { classes: {
                                tooltipRoot: styles_modules_less_1.default['title__icon-ctn'],
                            }, TippyProps: {
                                content: 'Enter a subject for this email',
                                placement: 'top',
                            } },
                            react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-info-circle', styles_modules_less_1.default.title__icon) }))),
                    react_1.default.createElement("span", { className: styles_modules_less_1.default['required-label'] }, "*Required")),
                react_1.default.createElement(pulse_components_1.PulseInput, { InputBaseProps: {
                        classes: {
                            input: (0, clsx_1.default)(styles_modules_less_1.default['subject-input__input'], errorSubject && styles_modules_less_1.default['subject-input__input--error']),
                        },
                        placeholder: 'Enter a subject',
                        onChange: onChangeSubject,
                    } })),
            react_1.default.createElement("div", { className: styles_modules_less_1.default['notifications-modal__input-ctn'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['notifications-modal__title'] },
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['notifications-modal__title--ctn'] },
                        react_1.default.createElement("label", { className: styles_modules_less_1.default['title--label'] }, "Email message"),
                        react_1.default.createElement(pulse_components_1.PulseTooltip, { classes: {
                                tooltipRoot: styles_modules_less_1.default['title__icon-ctn'],
                            }, TippyProps: {
                                content: 'Enter the message you want to send',
                                placement: 'top',
                            } },
                            react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-info-circle', styles_modules_less_1.default.title__icon) }))),
                    react_1.default.createElement("span", { className: styles_modules_less_1.default['required-label'] }, "*Required")),
                react_1.default.createElement("textarea", { className: (0, clsx_1.default)(styles_modules_less_1.default['notifications-modal__message'], errorMessage && styles_modules_less_1.default['notifications-modal__message--error']), onChange: onChangeMessage, placeholder: "Enter the message" })),
            react_1.default.createElement("label", { className: styles_modules_less_1.default['notify-user-options__label'] }, "Select reviewers to notify"),
            react_1.default.createElement(NotificationUsersOptions_1.default, { users: users, onCheckOption: onChangeSelectedOption, onSelectAllOption: onSelectAllOption, onSearchOption: onSearchOption, onAddSelectedUser: onAddSelectedUser }))));
};
exports.default = ManageNotificationsModal;
